import { forwardRef } from 'react';
import './table.overrides.css';
import { GoodTableProvider } from './table-context';
import { GoodTableRoot } from './table-root';
export const GoodTable = forwardRef(({ children, ...props }, ref) => {
    return (<GoodTableProvider>
      <GoodTableRoot ref={ref} {...props}>
        {children}
      </GoodTableRoot>
    </GoodTableProvider>);
});
